<template>
    <div>
        <Header />
        <TitlePage />
        <b-container>
            <b-img :src="`/images/activities/combo/combo.png`" fluid alt="Responsive image"></b-img>
            <b-row class="my-4">
                <b-col cols="12"  class="py-2"><h5>{{$t('ลงประกาศขายรถฟรี ที่ไทยรัฐ ซื้อขาย')}}</h5></b-col>
                <b-col cols="12"  class="py-2"><p>{{$t('ซื้อขายรถทุกชนิดฟรี ไม่ว่าจะเป็นรถบ้าน รถมือหนึ่ง รถมือสอง รถกระบะ รถเก๋ง รถตู้ รถสิบล้อ ลงประกาศฟรี ง่ายๆ ไม่มีค่าใช้จ่ายใดๆ ลงขายได้แล้ววันนี้')}} </p></b-col>
                <b-col cols="12"  class="py-2"><p>{{$t('พิเศษ!! ไทยรัฐซื้อขาย แจกโค้ดคอมโบ จำนวน 500 สิทธิ์ มูลค่ารวม 5,000 บาท')}} </p></b-col>
            </b-row>
            <b-row class="my-4">
                <b-col cols="12"  class="py-2"><h5>{{$t('เงื่อนไขในการใช้โค้ด')}}</h5></b-col>
                <b-col cols="12"  class="py-2">
                    <ol type="number">
                        <li>{{$t('จำกัดสิทธิ์ 1 โค้ดต่อ 1 ผู้ใช้งานเท่านั้น')}}</li>
                        <li>{{$t('ใช้ได้ในระยะเวลาวันที่ 15 - 23 มีนาคม 2565 เท่านั้น')}}</li>
                        <li>{{$t('ใช้โค้ดโปรโมตสินค้าให้เป็นสินค้าแนะนำ พิมพ์ TRCAR33 ในช่องรหัสส่วนลด โดยต้องเลือก แพ็คเกจ Combo ระยะเวลา 7 วันเท่านั้น')}}</li>

                    </ol>
                </b-col>
            </b-row>
            <b-row align-h="center">
                <b-col >{{$t('หมายเหตุ ขอสงวนสิทธิ์ในการเปลี่ยนแปลงโดยไม่ต้องแจ้งให้ทราบล่วงหน้า')}}</b-col>
            </b-row>
            <b-row class="my-5" align-content="center" >
                <b-col cols="12" md="3" class="text-center">
                    <b-img left   :src="`/images/activities/combo/TR-CN-01.JPG`" width="200" alt="Responsive image"></b-img>
                </b-col>
                <b-col cols="12" md="6" class="py-2"><h5>{{$t('วิธีการใช้โค้ดส่วนลด หรือโค้ดฟรี')}}</h5>
                    <ol type="number">
                        <li>{{$t('หากคุณมีรายการสินค้าอยู่แล้วบนเว็บไซต์ไทยรัฐ ซื้อ-ขาย สามารถไปที่ หน้าจัดการประกาศของคุณ')}}
                            <ul>
                                 <li>หน้าจัดการประกาศตลาด <a
                  id="faq-how-to-post-listing"
                  href="https://classifieds.thairath.co.th/th/user-manage/"
                  target="_blank"
                  style="color:blue"
                  >(คลิกที่นี่)</a></li>
                                <li>หน้าจัดการประกาศอสังหาริมทรัพย์ <a
                  id="faq-how-to-post-listing"
                  href="https://property.thairath.co.th/th/user-manage/"
                  target="_blank"
                  style="color:blue"
                  >(คลิกที่นี่)</a></li>
                            </ul>
                        </li>
                        <li>{{$t('กดโปรโมตที่รายการสินค้าของคุณ')}} </li>
                    </ol>

                </b-col>
            </b-row>
            <b-row class="my-5" align-content="center">
                <b-col cols="12" md="3" class="text-center">
                    <b-img left   :src="`/images/activities/combo/TR-CN-02.JPG`" width="200" alt="Responsive image"></b-img>
                </b-col>
                <b-col cols="12" md="6" class="py-3"><p>{{$t('3.เลือกโปรโมตแบบคอมโบ และเลือกระยะเวลา 7 วัน')}}</p>
                </b-col>
            </b-row>
            <b-row class="my-5" align-content="center">
                <b-col cols="12" md="3" class="text-center">
                    <b-img left   :src="`/images/activities/combo/TR-CN-03.JPG`" width="200" alt="Responsive image"></b-img>
                </b-col>
                <b-col cols="12" md="6" class="py-3"><p>{{$t('4.ใส่โค้ดส่วนลด ‘TRCAR33’ กดใช้ส่วนลด หลังจากนั้นก็กดขั้นตอนถัดไปได้เพื่อเสร็จสิ้นการใช้โค้ดส่วนลดได้เลย')}}</p>
                    <p>ดูวิธีการใช้โค้ดส่วนลดเพิ่มเติมได้ที่  <router-link
                    id="faq-how-to-post-listing"
                    :to="$i18nRoute({ name: 'topics/how-to-post-listing' })"
                    target="_blank"
                    style="color:blue"
                    >คลิกที่นี่</router-link></p>
                </b-col>
            </b-row>
            <b-row>
                <b-col><p>{{$t('5.หากคุณเพิ่งลงประกาศสินค้าใหม่ หลังจากกดลงประกาศสินค้าเสร็จเรียบร้อย คุณสามารถกดเลือก โปรโมตแบบคอมโบ และใส่โค้ดส่วนลด (ตามข้อที่ 3 และข้อที่ 4 )')}}</p></b-col>
            </b-row>
            <b-row>
                <b-col><p>{{$t('หากมีข้อสงสัยเพิ่มเติมสามารถติดต่อสอบถามได้ที่ Chat Support ของ ไทยรัฐ ซื้อ-ขาย หรือที่อีเมล Support@thairathclassifieds.co.th')}}</p></b-col>
            </b-row>
           
        </b-container>
        <Footer :adsFooter="adsFooter" />
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import Header from "@/components/ui/header";
import TitlePage from "@/components/ui/titlePage";
import Footer from "@/components/ui/footer";
export default {
  name: "ActivitiesCombo",
  components: {
    Header,
    TitlePage,
    Footer,
  },
  data() {
    return {
      adsFooter: null,
      windowHeight:window.innerHeight - 435
    };
  },
  computed: {
    ...mapGetters("UserController", [ "isMobile"]),
  },
  mounted() {
       this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
      this.onResize();
    });
  },
  methods: {
    updateScroll(elemenetId) {
      setTimeout(function () {
        document
          .getElementById(elemenetId)
          .scrollIntoView({ behavior: "smooth" });
      }, 700);
    },
    onResize(){
        this.windowHeight=window.innerHeight - 435
    }
  },
};
</script>
<style scoped lang="scss">
.mobile-scroll{
    overflow-y: scroll;
    margin-top: 200px;
}
.scroll-class{
max-height: 884px; overflow-y: scroll
}
.mobile-fixed{
    position: fixed;
}
.divider {
			height: 2px;
			border-top: 2px solid var(--projectPrimaryColor);
		}
</style>